import { useGetListDevicesBySnQuery } from '../redux/devicesApi';
import { getDeviceSnsFromSubs, getOrderIdsFromCharges } from '../utils/helpers';
import { useGetListSubscriptionsQuery } from '../redux/subscriptionsApi';
import {
  useGetListChargesQuery,
  useGetListPreviousChargesQuery,
} from '../redux/chargesApi';
import {
  injectDeviceIntoLineItems,
  injectPaymentsDataIntoCharge,
} from '../utils/charges';
import { useGetListPaymentsByOrderIdsQuery } from '../redux/ordersApi';

const useGetCharges = (params, previous = false) => {
  const { data: chargesRechargeData, isFetching: loadingRechargeChargesData } =
    useGetListChargesQuery(params, {
      skip: previous,
    });
  const { data: prevChargesData, isFetching: loadingPrevChargesData } =
    useGetListPreviousChargesQuery(params, {
      skip: !previous,
    });
  const chargesData = previous ? prevChargesData : chargesRechargeData;
  const loadingChargesData = previous
    ? loadingPrevChargesData
    : loadingRechargeChargesData;
  const { data: subscriptionsData } = useGetListSubscriptionsQuery();
  const devicesIds = getDeviceSnsFromSubs(subscriptionsData || []);
  const orderIds = getOrderIdsFromCharges(chargesData || []);
  const { data: devicesData, isFetching: loadingDeviceData } =
    useGetListDevicesBySnQuery(devicesIds, {
      skip: !devicesIds?.length > 0,
    });
  const { data: paymentsData, isFetching: loadingPaymentsData } =
    useGetListPaymentsByOrderIdsQuery(orderIds, {
      skip: !orderIds?.length > 0 || !previous,
    });
  const chargesWithDeviceInfo = injectDeviceIntoLineItems(
    subscriptionsData,
    chargesData,
    devicesData,
  );
  const nextCursor = chargesData?.next_cursor;
  const prevCursor = chargesData?.previous_cursor;
  let charges;
  let chargesLoading;
  if (params.status === 'queued') {
    chargesLoading = loadingChargesData || loadingDeviceData;
    charges = chargesWithDeviceInfo;
  } else {
    charges = injectPaymentsDataIntoCharge(chargesWithDeviceInfo, paymentsData);
    chargesLoading =
      loadingChargesData || loadingDeviceData || loadingPaymentsData;
  }

  return [charges, chargesLoading, { nextCursor, prevCursor }];
};

export default useGetCharges;
